export default {
  USERS: '/users',
  USERS_ID: '/users/{id}',
  USERS_SELF: '/users/self',
  DATASETS: '/datasets',
  DATASETS_ID: '/datasets/{id}',
  DATASETS_ID_DOWNLOAD: '/datasets/{id}/download',
  DATASETS_ID_RELEASES: '/datasets/{id}/releases',
  DATASETS_ID_RELATIONSHIPS_SHARINGGROUPS: '/datasets/{id}/relationships/sharingGroups',
  RELEASES: '/releases',
  RELEASES_ID: '/releases/{id}',
  CATALOGS_ID: '/catalogs/{id}',
  DATA: '/data',
  DATA_ID: '/data/{id}',
  DATA_ID_FILES: '/data/{id}/files',
  DATA_ID_VIRUSSCANFILES: '/data/{id}/virusScanFiles',
  DATA_ID_RELATIONSHIPS_FILES: '/data/{id}/relationships/files',
  DATACSV: '/datacsv',
  RESTRUCTUREREQUEST: '/restructureRequests',
  RESTRUCTUREREQUESTASCSV: '/restructureRequestsAsCsv',
  RESTRUCTUREREQUEST_ID: '/restructureRequests/{id}',
  DATASETTEMPLATES: '/datasetTemplates',
  DATASETTEMPLATES_ID: '/datasetTemplates/{id}',
  CATALOGSCHEMAS_ID: '/catalogSchemas/{id}',
  INVOICESCHEMAS_ID: '/invoiceSchemas/{id}',
  METADATADEFS_ID: '/metadataDefs/{id}',
  INVOICES_ID: '/invoices/{id}',
  GROUPS: '/groups',
  GROUPS_ID: '/groups/{id}',
  GROUPS_ID_MEMBERS: '/groups/{id}/members',
  LICENSES: '/licenses',
  FILES_ID: '/files/{id}',
  SEARCH_RESULTS: '/searchResults',
  UPLOADS: '/uploads',
  UPLOADS_ID: '/uploads/{id}',
  ENTRIES: '/entries',
  ENTRIES_ID: '/entries/{id}',
  ENTRIES_ID_VIRUSSCANFILES: '/entries/{id}/virusScanFiles',
  SAMPLES: '/samples',
  SAMPLES_ID: '/samples/{id}',
  SAMPLES_ID_RELATIONSHIPS_SHARINGGROUPS: '/samples/{id}/relationships/sharingGroups',
  SAMPLETERMS: '/sampleTerms',
  SAMPLECLASSES: '/sampleClasses',
  INSTRUMENTS: '/instruments',
  INSTRUMENTS_ID: '/instruments/{id}',
  ORGANIZATIONS: '/organizations',
  INSTRUMENTGROUPS: '/instrumentGroups',
  TYPETERMS: '/typeTerms',
  PROGRAMS: '/programs'
};
